import { logToDataLayer } from './LogHelper';

export const logCombinationSummary = (loggingData) => {
  if (loggingData) {
    logToDataLayer({
      event: loggingData.event,
      eventCategory: 'Travel',
      eventAction: 'Combination',
      eventLabel: 'Summary',
      travelAdults: loggingData.numberOfAdults,
      travelChildren: loggingData.numberOfChildren,
      travelPax: loggingData.numberOfPassengers,
      travelAges: loggingData.passengerAges,
      travelType: loggingData.travelType,
      travelDepartureDay: loggingData.departureDateDay,
      travelDepartureMonth: loggingData.departureDateMonth,
      travelDepartureYear: loggingData.departureDateYear,
      travelDuration: loggingData.duration,
      // The API sends '' when the package has no hotels to take a country from; GA wants the key absent then.
      travelCountryCode: loggingData.countryCode || undefined,
      travelDepartureCode: loggingData.departureCode,
      travelDestinationCode: loggingData.destinationCode,
      travelAction: loggingData.action,
      travelTdmId: loggingData.tdmRuleId,
      travelTdmName: loggingData.tripRuleName,
    });
  }
};

// Bare on purpose: GTM reuses the travel params the preceding summary push left in the dataLayer.
export const logPackagePlusSearch = () => {
  logToDataLayer({ event: 'Search' });
};

export const logCruiseSummary = (loggingData, cruise) => {
  if (loggingData && cruise) {
    const itinerary = cruise?.itinerary?.map((stop) => stop.resort)?.join(',');

    logToDataLayer({
      event: 'cruise_summary',
      eventCategory: 'Travel',
      eventAction: 'Cruise',
      eventLabel: 'Summary',
      travelAdults: loggingData.numberOfAdults,
      travelChildren: loggingData.numberOfChildren,
      travelPax: loggingData.numberOfPassengers,
      travelAges: loggingData.passengerAges,
      travelType: 'CruisePackage',
      travelDepartureDay: loggingData.departureDateDay,
      travelDepartureMonth: loggingData.departureDateMonth,
      travelDepartureYear: loggingData.departureDateYear,
      travelDuration: parseInt(loggingData.duration, 10) > 0 ? loggingData.duration : 'NoneChosen',
      travelCountryCode: loggingData.countryCode,
      travelDepartureCode: loggingData.departureCode,
      travelDestinationCode: loggingData.destinationCode,
      travelAction: loggingData.action,
      travelTdmId: loggingData.tdmRuleId,
      travelTdmName: loggingData.tripRuleName,
      travelCruiseCode: cruise.cruiseCode,
      travelCruiseName: cruise.cruiseName,
      travelCruiseShipCode: cruise.cruiseShipCode,
      travelCruiseShipName: cruise.cruiseShipName,
      travelCruiseCompanyCode: cruise.cruiseCompanyCode,
      travelCruiseCompanyName: cruise.cruiseCompanyName,
      travelCruiseItinerary: itinerary,
      travelCruiseArea: loggingData.areaWvId,
    });
  }
};

export const logAddCruiseToCart = (packageData, siteId) => {
  let currency = 'SEK';

  switch (siteId) {
    case 1:
    case 18:
      currency = 'SEK';
      break;
    case 3:
      currency = 'NOK';
      break;
    case 11:
      currency = 'DKK';
      break;
    case 15:
      currency = 'EUR';
      break;

    default:
      break;
  }

  logToDataLayer({
    event: 'addToCart',
    ecommerce: {
      currencyCode: currency,
      add: {
        products: [
          {
            name: packageData?.tripRuleName,
            id: packageData?.tdmRuleId,
            price: packageData?.totalPriceRounded,
            brand: packageData.cruise.cruiseCompanyName,
            category: 'CruisePackage',
            variant: 'VITS',
          },
        ],
      },
    },
  });
};
